<div class="category-list {{category}}-wrapper ">
    <div class="category-info">
        <span class="category-name">{{nameCategory}}</span>
        <p class="category-description">{{descriptionCategory}}.</p>
    </div>
    <p class="not-found hide">No calls found based on your search</p>
    <ul class="things-list {{category}}-list show-all">
    </ul>
</div>